import { NgModule } from '@angular/core';
import { NDDDialogModule, NDDDialogService } from '@ndk/ng-dialog';

import { CustomDialogService } from './custom-dialog.service';

@NgModule({
    imports:[
        NDDDialogModule,
    ],
    exports:[
        NDDDialogModule,
    ],
    providers:[
        {
            provide: NDDDialogService,
            useClass: CustomDialogService,
        },
    ],
})
export class CustomDialogModule { }
